import styled from "styled-components";

import { FlexContainer, FlexDiv, SVGSprite } from "@/components/Atoms";
import theme from "@/foundation/Theme";

export const Wrapper = styled(FlexDiv)`
  background-color: ${theme.colors.lightBlue};
  padding: 54px 0;
  @media only screen and (max-width: 1169px) {
    background-color: ${theme.colors.white};
    padding: 0;
  }
`;

export const Col = styled(FlexDiv)`
  max-width: 60%;
  padding: 0 15px;
  width: 100%;
  justify-content: flex-end;
`;

export const LCol = styled(FlexDiv)`
  max-width: 40%;
  padding: 0 15px;
  justify-content: flex-start;
`;

export const UList = styled.ul`
  padding-left: 0;
  margin: 0;
`;

export const Icon = styled(SVGSprite)`
  height: 37px;
  width: 37px;
`;

export const ListItem = styled.li`
  list-style: none;
  margin-bottom: 33px;
  &:last-child {
    margin-bottom: 0;
  }
  padding-left: 57px;
  position: relative;
  ${Icon} {
    position: absolute;
    top: 4px;
    left: 0;
  }
  @media only screen and (max-width: 1169px) {
    padding-left: 37px;
    ${Icon} {
      height: 25px;
      width: 25px;
    }
  }
`;

export const CallBackFormBox = styled(FlexDiv)`
  background-color: ${theme.colors.white};
  padding: 35px;
  border: 1px solid ${theme.colors.border1};
  border-radius: 10px;
  width: 502px;
`;

export const Group = styled(FlexContainer)`
  @media only screen and (max-width: 1169px) {
    flex-direction: column;
    padding: 0;
    ${LCol} {
      order: 1;
      background-color: ${theme.colors.lightBlue};
      padding: 52px 15px;
    }
    ${Col} {
      margin-bottom: 35px;
      order: 0;
      ${CallBackFormBox} {
        border: 0;
        padding: 35px 20px;
      }
    }
    ${Col},${LCol} {
      max-width: 100%;
      justify-content: center;
    }
  }
`;
